module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "chip.6ab04c33.png" + "?" + Date.now();